import { useState } from 'react';

import { Alert } from 'antd';

import AttendanceCard from 'components/Pages/Admin/CheckinPage/QrCodeScanner/AttendanceCard';
import { Attendance } from 'components/Pages/Admin/CheckinPage/QrCodeScanner/types';

import styles from './styles.module.css';
import CheckinHistoryModal from '../../../CheckinsHistoryModal';

type ScanResultProps = {
  attendance: Attendance | null;
  errorMessage: string | null;
  loading: boolean;
  staffToken: string;
  clearScanContent: () => void;
};

const ScanResult = ({ attendance, errorMessage, loading, staffToken, clearScanContent }: ScanResultProps) => {
  const [checkinHistoryVisible, setCheckinHistoryVisible] = useState(false);

  if (loading) {
    return null;
  }

  if (!attendance && !errorMessage) {
    return null;
  }

  return (
    <div className={styles.container}>
      {errorMessage && <Alert message={errorMessage} type='error' />}
      {attendance && !errorMessage && (
        <>
          <AttendanceCard attendance={attendance} hideButtons={true} staffToken={staffToken} />
        </>
      )}
      {attendance && (
        <>
          <button className={styles.button} onClick={() => setCheckinHistoryVisible(true)}>
            Check-ins realizados pelo credenciador
          </button>

          <CheckinHistoryModal
            staffToken={staffToken}
            visible={checkinHistoryVisible}
            onClose={() => {
              setCheckinHistoryVisible(false);
              clearScanContent();
            }}
          />
        </>
      )}
    </div>
  );
};

export default ScanResult;
